<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header header-elements-inline">
            <h5 class="card-title">Search Time Cards</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 col-md-6 sol-sm-12">
                <div class="form-group">
                  <label>Date:</label>
                  <el-date-picker
                    ref="datePicker"
                    v-model="searchDate"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="to"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    :picker-options="pickerOptions"
                    format="MMM dd, yy"
                    @change="
                      dateChanged(searchDate);
                      setShowNoTimeCardMessage();
                    "
                  ></el-date-picker>
                  <div v-if="searchDateError">
                    <span>{{ searchDateMessage }}</span>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 sol-sm-12">
                <div class="form-group">
                  <label>Employee:</label>
                  <!-- this needs to be a ddl of employees -->
                  <v-select
                    :options="users"
                    label="name"
                    v-model="selectedEmployee"
                  ></v-select>
                  <div v-if="searchEmployeeError">
                    <span>{{ searchEmployeeMessage }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <el-switch
                  style="display: block"
                  v-model="showIncompleteToggle"
                  active-color="#13ce66"
                  inactive-color="#ad466c"
                  active-text="Show Incomplete Time Cards"
                  avtive-value="true"
                  @change="updateIncompleteFlag"
                ></el-switch>
              </div>
              <div class="col-6">
                <div class="text-right">
                  <button
                    type="button float-right"
                    class="btn btn-primary mr-2"
                    v-bind:disabled="selectedEmployee == null"
                    v-on:click="addTimeCard"
                  >
                    Add Time Card
                    <i class="icon-plus3 ml-2"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="searchCards"
                    :disabled="searchButtonDisabled"
                  >
                    Search
                    <i class="icon-search4 ml-2"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="printTotals" class="col-12">
        <timeCardTotals />
      </div>
      <br />
      <div
        v-for="(week, index) in timeCardCollection"
        v-bind:key="`tcc1_${index}`"
        class="row"
        style="width: 100%; display: inline-flex"
      >
        <timeCard
          v-for="(timeCard, index) in week.timeCards"
          v-bind:key="`timecard1_${week.employeeId}_${index}`"
          v-bind:index="index"
          v-bind:id="timeCard.id"
          v-bind:date="timeCard.date"
          v-bind:approved="timeCard.approved"
          v-bind:times="timeCard.times"
          v-bind:name="timeCard.name"
          v-bind:type="timeCard.type"
          v-bind:dateApproved="timeCard.dateApproved"
          v-bind:lastRegTime="week.lastRegTime"
          v-bind:otIndex="week.otIndex"
          v-bind:approvedBy="timeCard.approvedBy"
          v-bind:regularHours="timeCard.regularHours"
          v-bind:holidays="holidays"
          v-bind:vacation="timeCard.vacation"
          v-bind:uid="timeCard.uid"
          v-bind:timeSpanTypes="timeSpanTypes"
          v-bind:passedEditComment="timeCard.editComment"
          v-bind:incomplete="timeCard.incomplete"
          v-bind:showLocation="true"
          :averagingAgreement="
            timeCard.averagingAgreement ? timeCard.averagingAgreement : null
          "
          :users="users"
          :ref="'timeCardCollection_' + week.employeeId"
          @deleteTimeCard="deleteTimeCard"
          ></timeCard>
      </div>
      <!-- //If no time cards are available for the selected time, show message, message will disappear upon selection of new date via the showNoTimeCardMessage variable that changes to false upon selection of new date, and true upon clicking the search button -->
      <h3 v-if="determineIfTimeCardsPresent() && showNoTimeCardMessage">
        There are no time cards available for the time selected
      </h3>
    </div>
    <!-- Add Time Card Modal -->
    <add-time-card
      v-if="showAddTimeCardModal"
      v-bind:showModal="showAddTimeCardModal"
      :selectedEmployee="selectedEmployee"
      :searchDate="searchDate[0]"
      @closeAddModal="closeAddModal"
      @reloadCards="searchCards"
    />
    <!-- /Add Time Card Modal -->
  </div>
</template>

<script>
import timeCard from '../components/timeCard.vue';
import timeCardTotals from '../components/timeCardTotals.vue';
import addTimeCard from '../components/addTimeCardModal.vue';
import { db } from '../assets/js/firebase/db.js';
import moment from 'moment';
import { getHolidays } from '../assets/js/helpers/holidays.js';
import { roundToQuarter } from '../assets/js/helpers/hoursCalculations.js';
import { getWeeksFromDateRange } from '../assets/js/helpers/dates.js';

export default {
  name: 'searchTimeCards',
  components: {
    timeCard,
    timeCardTotals,
    addTimeCard
  },
  data() {
    return {
      searchButtonDisabled: false,
      timeCardCollection: [],
      lastRegTime: null,
      otIndex: null,
      users: [],
      timeSpanTypes: [],
      selectedEmployee: null,
      searchDate: null,
      showEditModal: false,
      editTimeCardMessage: null,
      showEditAlert: false,
      showAddTimeCardModal: false,
      editTimeCardName: null,
      editTimeCardDate: null,
      editTimeCardID: null,
      editTimeCardTimes: [],
      deleteVisible: false,
      deleteID: null,
      holidays: [],
      holidaysInTimeSpan:[],
      searchDateError: false,
      searchDateMessage: null,
      searchEmployeeError: false,
      searchEmployeeMessage: null,
      showNoTimeCardMessage: false,
      showIncompleteToggle: false,
      allEmployeesTimeCardData: [],
      minDate: undefined,
      maxDate: undefined,
      disabledDays: [1, 2, 3, 4, 5, 6],
      pickerOptions: {
        shortcuts: [
          {
            text: 'This Week',
            onClick(picker) {
              const start = moment().startOf('week');
              const end = moment().endOf('week');
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: 'Last Week',
            onClick(picker) {
              const start = moment()
                .add('week', -1)
                .startOf('week');
              const end = moment()
                .add('week', -1)
                .endOf('week');
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '2 Weeks Ago',
            onClick(picker) {
              const start = moment()
                .add('week', -2)
                .startOf('week');
              const end = moment()
                .add('week', -2)
                .endOf('week');
              picker.$emit('pick', [start, end]);
            }
          }
        ],
        disabledDate: time => {
          //only allow sundays and saturdays to be picked.
          let date = new Date(time).getDay();
          return this.disabledDays.includes(date);
        },
        onPick: ({ minDate, maxDate }) => {
          if (minDate && maxDate) {
            this.searchDate = [minDate, maxDate];
            this.closeDatePicker();

            // Reset disabledDays to use range selection after closing the calendar
            this.disabledDays = [1, 2, 3, 4, 5, 6];
          } else if (minDate && !maxDate) {
            const day = minDate.getDay();
            if (day === 0) {
              this.disabledDays = [0, 1, 2, 3, 4, 5];
            } else {
              this.resetPicker();
            }
          } else {
            this.resetPicker();
          }
        }
      },
  };
  },
  methods: {
    getHolidays: async function(startDate, endDate) {
      this.holidays = [];
      let startYear = Number(moment(startDate).format('YYYY'));
      let numberOfYears =
        Number(moment(endDate).format('YYYY')) -
        Number(moment(startDate).format('YYYY'));
      //get the list of holidays for the year that the user has selected.
      for (let i = 0; i <= numberOfYears; i++) {
        try {
          let response = await getHolidays(startYear.toString());
          for (
            let i = 0;
            i <= response.data.provinces[0].holidays.length - 1;
            i++
          ) {
            this.holidays.push(response.data.provinces[0].holidays[i].date);
          }
        } catch (err) {
          console.log(`Error getting holidays ${err}`);
        }
        startYear++;
      }
    },
    calculateHolidays: function() {
      //add all holidays in the time span selected to an array
      this.holidaysInTimeSpan = [];
      this.holidays.forEach(holiday => {
        if (
          moment(holiday).isBetween(
            this.searchDate[0],
            this.searchDate[1],
            undefined,
            '[]'
          )
        ) {
          holiday = moment(holiday).format('MMM DD, YY');
          if (!this.holidaysInTimeSpan.includes(holiday)) {
            this.holidaysInTimeSpan.push(holiday);
          }
        }
      });
    },
    setShowNoTimeCardMessage: function() {
      this.showNoTimeCardMessage = false;
    },
    searchCards: async function() {
      if (this.validateSearch() == true) {
        //clear the totals.
        this.$store.commit('clearTotals');
        this.timeCardCollection = [];
        //disable the search button until the timecards are
        //loaded into the table
        this.searchButtonDisabled = true;
        //need to slpit the date range into weeks, so we can do weekly OT calculations.
        let weeks = getWeeksFromDateRange(
          this.searchDate[0],
          this.searchDate[1]
        );
        //get holidays and calculate holidays in the time span selected
      await this.getHolidays(this.searchDate[0], this.searchDate[1]);
      this.calculateHolidays();

        for (let week of weeks) {
          await this.getTimeCards(
            this.selectedEmployee,
            moment(week.startOfWeek).startOf('day'),
            moment(week.endOfWeek).endOf('day')
          );
        }
        this.searchButtonDisabled = false;

        //change show no time card message to true upon click of search button
        this.showNoTimeCardMessage = true;
      }
    },
    getTimeCards: async function(employee, startDate, endDate) {
      //create the query based off of the selections.
      
      let query = db
        .collection('timeCards')
        .where('date', '>=', new Date(startDate))
        .where('date', '<=', new Date(endDate))
        .where('company', '==', this.$store.state.userCompany)
        .where('user', '==', employee.id);
      // this.timeCardCollection = [];
      //run out to the store and grab a pack of time cards.
      await query
        .get()
        .then(querySnapshot => {
          let tempArg = {
            employeeId: employee.id,
            timeCards: []
          };
          querySnapshot.forEach(doc => {
            let complete = true;
            for (let i = 0; i <= doc.data().times.length - 1; i++) {
              if (doc.data().times[i].endTime == null) {
                complete = false;
              }
            }
            //show incomplete time cards if the toggle is active. If the toggle is not acitve, only show complete time cards.
            if (this.showIncompleteToggle) {
              tempArg.timeCards.push({
                id: doc.id,
                date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
                times: doc.data().times,
                approved: doc.data().approved,
                approvedBy:
                  doc.data().approvedBy == undefined
                    ? null
                    : doc.data().approvedBy,
                name: doc.data().name,
                type: doc.data().type,
                dateApproved:
                  doc.data().dateApproved == undefined
                    ? null
                    : moment(doc.data().dateApproved.toDate()).format(
                        'MMM DD, YY hh:mm'
                      ),
                vacation: doc.data().vacation,
                uid: doc.data().user,
                averagingAgreement: doc.data().averagingAgreement
                  ? doc.data().averagingAgreement
                  : null,
                incomplete: !complete
              });
            } else if (complete) {
              //TODO: Make it so we can toggle showing unapproved and incomplete timecards.
              //only going to display time cards that have an end time on this.
              tempArg.timeCards.push({
                id: doc.id,
                date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
                times: doc.data().times,
                approved: doc.data().approved,
                approvedBy:
                  doc.data().approvedBy == undefined
                    ? null
                    : doc.data().approvedBy,
                name: doc.data().name,
                type: doc.data().type,
                dateApproved:
                  doc.data().dateApproved == undefined
                    ? null
                    : moment(doc.data().dateApproved.toDate()).format(
                        'MMM DD, YY hh:mm'
                      ),
                vacation: doc.data().vacation,
                uid: doc.data().user,
                averagingAgreement: doc.data().averagingAgreement
                  ? doc.data().averagingAgreement
                  : null,
                editComment:
                  doc.data().editComment != undefined
                    ? doc.data().editComment
                    : null,
                incomplete: !complete
              });
            }
          });
          let sum = 0;
          let index = -1;
          let lastHours = 0;
          let dayAdd = 0;
          //sort the time cards by date becuase we possibly added a time card for the holiday at the end of the array.
          tempArg.timeCards.sort(function(a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(a.date) - new Date(b.date);
          });
          for (let i = 0; i <= tempArg.timeCards.length - 1; i++) {
            //only do this for the completed timecards.
            // if (!tempArg.timeCards[i].incomplete) {
            //itterate all of the times can get a total.
            let daysum = 0;
            for (let t = 0; t <= tempArg.timeCards[i].times.length - 1; t++) {
              tempArg.timeCards[i].times[t] = {
                times: [
                  tempArg.timeCards[i].times[t].startTime.toDate(),
                  tempArg.timeCards[i].times[t].endTime != undefined
                    ? tempArg.timeCards[i].times[t].endTime.toDate()
                    : undefined
                ],
                type: tempArg.timeCards[i].times[t].type,
                job: tempArg.timeCards[i].times[t].job
                  ? tempArg.timeCards[i].times[t].job
                  : null,

                notes: tempArg.timeCards[i].times[t].notes,
                startLocation: {
                  latitude:
                    tempArg.timeCards[i].times[t].startLocation != undefined
                      ? tempArg.timeCards[i].times[t].startLocation.latitude
                      : null,
                  longitude:
                    tempArg.timeCards[i].times[t].startLocation != undefined
                      ? tempArg.timeCards[i].times[t].startLocation.longitude
                      : null
                },
                endLocation: {
                  latitude:
                    tempArg.timeCards[i].times[t].endLocation != undefined
                      ? tempArg.timeCards[i].times[t].endLocation.latitude
                      : null,
                  longitude:
                    tempArg.timeCards[i].times[t].endLocation != undefined
                      ? tempArg.timeCards[i].times[t].endLocation.longitude
                      : null
                }
              };
              let start = moment(tempArg.timeCards[i].times[t].times[0]);
              let end = moment(tempArg.timeCards[i].times[t].times[1]);
              if (
                !this.holidays.includes(
                  moment(tempArg.timeCards[i].date).format('YYYY-MM-DD')
                )
              ) {
                // daysum += moment.duration(end.diff(start)).asHours();
                daysum += Number(roundToQuarter(moment.duration(end.diff(start)).asHours()));
              }
              if (
                tempArg.timeCards[i].times[t].type == 'travel time' ||
                tempArg.timeCards[i].times[t].type == 'on call' ||
                tempArg.timeCards[i].times[t].type == 'ot exempt'
              ) {
                //the travel time and on call times need to be removed from the weekly ot count.
                daysum -= Number(roundToQuarter(moment.duration(end.diff(start)).asHours()));
              }
            }
            if (tempArg.timeCards[i].type == 'employee') {
              if (roundToQuarter(daysum) >= 8) {
                sum += 8;
                dayAdd = 8;
              } else {
                sum += Number(roundToQuarter(Number(daysum)));
                dayAdd = Number(roundToQuarter(Number(daysum)));
              }
              if (sum >= 44 && index == -1) {
                //this algorithm was a thinker.
                //x = o-(s-c)
                //x = the regular time that is applied to reach the total of 44 hours worked in a work week.
                //o = the weekly ot maximum.
                //s = weekly sum
                //c = current day's regular hours that would be applied to the sum
                lastHours = 44 - (sum - dayAdd);
                index = i;
              }
            } else if (tempArg.timeCards[i].type == 'driver') {
              if (roundToQuarter(daysum) >= 10) {
                sum += 10;
                dayAdd = 10;
              } else {
                sum += parseFloat(roundToQuarter(parseFloat(daysum)));
                dayAdd = parseFloat(roundToQuarter(parseFloat(daysum)));
              }
              if (sum >= 50 && index == -1) {
                lastHours = 50 - (sum - dayAdd);
                index = i;
              }
            }
            // }
          }
          //this is the time card that will go over the weekly maximum
          tempArg.lastRegTime = lastHours;
          tempArg.otIndex = index;
          this.lastRegTime = lastHours;
          this.otIndex = index;
          let possibleIndex = this.timeCardCollection.findIndex(
            o => o.employeeId == employee.id
          );
          //check to see if our value exists, if it doesn't, jjust push to the array.
          // if (possibleIndex >= 0) {
          //exists. overwrite the value.
          // this.timeCardCollection[possibleIndex].timeCards.push(tempArg);
          // } else {
          //doesn't exist. append to the array.
          this.timeCardCollection.push(tempArg);
          // }
        })
        .then(() => {
          //itterate the refs in a chained "then", so we can access them.
          //push the totals to the all employee array.
          let totals = {
            employee: employee.name,
            employeeId: employee.id,
            regularTotal: 0,
            total: 0,
            otTotal: 0,
            travelTimeTotal: 0,
            statTotal: 0,
            onCallHoursTotal: 0
          };
          if (this.$refs[`timeCardCollection_${employee.id}`] != undefined) {
            for (
              let i = 0;
              i <= this.$refs[`timeCardCollection_${employee.id}`].length - 1;
              i++
            ) {
              //check to see if the time card date is in between the dates the user chose. We are only counting the time cards in that selection.
              if (
                moment(
                  this.$refs[`timeCardCollection_${employee.id}`][i].date
                ).isBetween(
                  this.searchDate[0],
                  this.searchDate[1],
                  undefined,
                  '[]'
                )
              ) {
                totals.regularTotal += parseFloat(
                  this.$refs[`timeCardCollection_${employee.id}`][i]
                    .regularHours
                );
                totals.total += parseFloat(
                  this.$refs[`timeCardCollection_${employee.id}`][i].total
                );
                totals.otTotal += parseFloat(
                  this.$refs[`timeCardCollection_${employee.id}`][i].otHours
                );
                totals.travelTimeTotal += parseFloat(
                  this.$refs[`timeCardCollection_${employee.id}`][i].travelTime
                );
                totals.onCallHoursTotal += parseFloat(
                  this.$refs[`timeCardCollection_${employee.id}`][i].onCallHours
                );
                totals.statTotal += parseFloat(
                  this.$refs[`timeCardCollection_${employee.id}`][i].statTime
                );
              }
            }
            //round the totals before setting them to the timecards.
            totals.regularTotal = totals.regularTotal.toFixed(2);
            totals.total = totals.total.toFixed(2);
            totals.otTotal = totals.otTotal.toFixed(2);
            totals.travelTimeTotal = totals.travelTimeTotal.toFixed(2);
            totals.onCallHoursTotal = totals.onCallHoursTotal.toFixed(2);
            totals.statTotal = totals.statTotal.toFixed(2);
            //check to see if this employee has a time in the totals object already. if they do, overwrite it. If not, append it.
            let possibleIndex = this.allEmployeesTimeCardData.findIndex(
              o => o.employeeId == employee.id
            );
            //check to see if our value exists, if it doesn't, jjust push to the array.
            if (possibleIndex >= 0) {
              //the user already has a total. Add the totals to their previous totals.
              this.allEmployeesTimeCardData[possibleIndex].regularTotal = (
                parseFloat(
                  this.allEmployeesTimeCardData[possibleIndex].regularTotal
                ) + parseFloat(totals.regularTotal)
              ).toFixed(2);
              this.allEmployeesTimeCardData[possibleIndex].total = (
                parseFloat(this.allEmployeesTimeCardData[possibleIndex].total) +
                parseFloat(totals.total)
              ).toFixed(2);
              this.allEmployeesTimeCardData[possibleIndex].otTotal = (
                parseFloat(
                  this.allEmployeesTimeCardData[possibleIndex].otTotal
                ) + parseFloat(totals.otTotal)
              ).toFixed(2);
              this.allEmployeesTimeCardData[possibleIndex].travelTimeTotal = (
                parseFloat(
                  this.allEmployeesTimeCardData[possibleIndex].travelTimeTotal
                ) + parseFloat(totals.travelTimeTotal)
              ).toFixed(2);
              this.allEmployeesTimeCardData[possibleIndex].onCallHoursTotal = (
                parseFloat(
                  this.allEmployeesTimeCardData[possibleIndex].onCallHoursTotal
                ) + parseFloat(totals.onCallHoursTotal)
              ).toFixed(2);
              this.allEmployeesTimeCardData[possibleIndex].statTotal = (
                parseFloat(
                  this.allEmployeesTimeCardData[possibleIndex].statTotal
                ) + parseFloat(totals.statTotal)
              ).toFixed(2);
            } else {
              //doesn't exist. append to the array.
              this.allEmployeesTimeCardData.push(totals);
            }
          }
        })
        .catch(err => {
          console.log(employee.name);
          console.log(err);
        });
    },
    dateChanged: function(time) {
      //if the calendar was cleared, then we need reset the limited dates in the calendar.
      if (time === null) {
        this.disabledDays = [1, 2, 3, 4, 5, 6];
        this.minDate = undefined;
        this.maxDate = undefined;
      }
    },
    determineIfTimeCardsPresent: function() {
      let flag = true;
      this.timeCardCollection.forEach(week => {
        if (week.timeCards.length > 0) {
          flag = false;
        }
      });
      return flag;
    },
    deleteTimeCard: function(index) {
      this.timeCardCollection.splice(index, 1);
    },
    closeAddModal: function() {
      this.showAddTimeCardModal = false;
    },
    showSuccess: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'success'
      });
    },
    showError: function(message) {
      this.$toasted.show(message, {
        duration: '5000',
        keepOnHover: true,
        type: 'error'
      });
    },
    addTimeCard: function() {
      if (
        !this.searchDate ||
        this.searchDate.length === 0 ||
        !this.searchDate[0] ||
        !this.searchDate[1]
      ) {
        const currentDate = new Date();

        currentDate.setHours(0, 0, 0, 0);

        this.searchDate = [currentDate, currentDate];
      }

      this.showAddTimeCardModal = true;
    },
    validateSearch: function() {
      let flag = true;
      if (this.searchDate == null) {
        this.searchDateError = true;
        this.searchDateMessage = 'The date selection cannot be empty.';
        flag = false;
      } else {
        this.searchDateError = false;
        this.searchDateMessage = null;
        flag = true;
      }
      if (this.selectedEmployee == null) {
        this.searchEmployeeError = true;
        this.searchEmployeeMessage = 'The date selection cannot be empty.';
        flag = false;
      } else {
        this.searchEmployeeError = false;
        this.searchEmployeeMessage = null;
        flag = true;
      }
      return flag;
    },
    updateIncompleteFlag: function(val) {
      this.showIncompleteToggle = val;
      this.searchCards();
    },
    closeDatePicker() {
      if (
        this.$refs.datePicker &&
        typeof this.$refs.datePicker.handleClose === 'function'
      ) {
        this.$refs.datePicker.handleClose();
      }
    },
    resetPicker() {
      this.minDate = undefined;
      this.maxDate = undefined;
      this.searchDate = [];
      this.disabledDays = [1, 2, 3, 4, 5, 6];
    }
  },
  mounted() {
    db.collection('users')
      .where('company', '==', this.$store.state.userCompany)
      .orderBy('name', 'asc')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          if (this.$store.state.showInactiveEmployees == 'Yes') {
            this.users.push({
              id: doc.id,
              name: doc.data().name,
              averagingAgreement: doc.data().averagingAgreement
                ? doc.data().averagingAgreement
                : null,
              type: doc.data().type,
              userCategory: doc.data().userCategory
                ? doc.data().userCategory
                : null,
              vacation: doc.data().vacation
            });
          } else if (
            doc.data().deactiveDate == undefined ||
            doc.data().deactiveDate == null
          ) {
            this.users.push({
              id: doc.id,
              name: doc.data().name,
              averagingAgreement: doc.data().averagingAgreement
                ? doc.data().averagingAgreement
                : null,
              type: doc.data().type,
              userCategory: doc.data().userCategory
                ? doc.data().userCategory
                : null,
              vacation: doc.data().vacation
            });
          }
        });
      })
      .catch(err => {
        console.log('Error getting users.' + err);
      });
    //get the time span types for the timecard edits.
    db.collection('timeSpanTypes')
      .orderBy('name', 'asc')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.timeSpanTypes.push(doc.data().name);
        });
      })
      .catch(err => {
        console.log(`Error getting time span types: ${err}`);
      });
  }
};
</script>
